import React from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { Icon } from '@mobi/component-library/Common/V2/Icon'
import { spacing } from '@mobi/component-library/Theme/Common'

export const FieldToggle: React.FC<{
  enabled: boolean
  toggleFieldState: () => void
}> = ({ enabled, toggleFieldState }) => {
  const isFieldToggled = enabled
  const isResultsToggled = !enabled

  const resultsClicked = () => {
    if (!isResultsToggled) toggleFieldState()
  }
  const fieldClicked = () => {
    if (!isFieldToggled) toggleFieldState()
  }

  return (
    <FieldToggleContainerStyled>
      <label data-js-enabled={isResultsToggled} onClick={resultsClicked}>
        {isResultsToggled && <Icon name='LineCheck' color='inherit' size='inherit' />}
        Results
      </label>

      <label data-js-enabled={isFieldToggled} onClick={fieldClicked}>
        {isFieldToggled && <Icon name='LineCheck' color='inherit' size='inherit' />}
        Field
      </label>
    </FieldToggleContainerStyled>
  )
}

// ======
// Styles
// ======

const FieldToggleContainerStyled = styled.div({
  alignItems: 'center',
  backgroundColor: hexColors.white,
  boxSizing: 'border-box',
  display: 'flex',
  maxWidth: '100vw',
  overflowX: 'auto',
  padding: '1rem 1.2rem 1rem 1.2rem',
  whiteSpace: 'nowrap',

  '> label': {
    alignItems: 'center',
    border: 'none',
    borderRadius: '5px',
    boxSizing: 'border-box',
    display: 'inline-flex',
    gap: spacing.smx2,
    height: '2.6rem',
    justifyContent: 'center',
    padding: '0 1rem',
    backgroundColor: hexColors.gainsboro,
    color: hexColors.matterhorn,
    marginRight: '1rem',
    fontSize: '1.2rem',

    '&[data-js-enabled="true"]': {
      backgroundColor: hexColors.lavenderBlue,
      color: hexColors.blueDiamond,
    },

    '> svg': {
      marginRight: '0.4rem',
    },
  },
})
